import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { ToastContainer } from 'react-toastify';

const Admins = () => {
    const base_url = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem('token');
    const [admins, setAdmins] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage] = useState(10)
    const [sortOrder, setSortOrder] = useState('asc')
    const [adminsPending, setAdminsPending] = useState(false)
    const [totalAdmins, setTotalAdmins] = useState(0)
    const [currentItems, setCurrentItems] = useState([])
    const [searchString, setSearchString] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const [selectedIndex, setSelectedIndex] = useState(0)

    // STATE MANAGEMENT FOR ACTIVE AND INACTIVE ADMINS
    const [statusPending, setStatusPending] = useState(false);

    const [notificationMessage, setNotificationMessage] = useState("");
    const [notificationSubject, setNotificationSubject] = useState("");
    const [notificationSending, setNotificationSending] = useState(false);
    const sortedAdmins = admins && Array.isArray(admins) ? (sortOrder === 'asc' ? [...admins] : [...admins].reverse()) : [];


    // Create an instance of Axios
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const viewAdmin = (index) => {
        // const clickedObject = products[index];
        setSelectedAdmin(admins[0])

        console.log("index clicked:" + index)
        console.log(selectedAdmin)
    }
    const successAlert = (msg) => toast.success(msg, {
        position: "top-center",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });
    const errorAlert = (msg) => toast.success(msg, {
        position: "top-center",
        autoClose: 1800,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light"
    });

    const fetchData = async () => {
        try {
            setAdminsPending(true)
            const response = await api.get(`${base_url}/user/get-all-admins`);
            setAdmins(response.data.result);
            setCurrentItems(response.data.result);
            setAdminsPending(false)
            console.log(admins)
        } catch (error) {
            console.log(error);
            // deleteAdminError("An error occured while trying to delete entry. Try again or contact support")
        }
    };

    useEffect(() => {
        fetchData();
        //check total admins
        // api.get(`${base_url}/user/total-users/all`)
        //     .then(function (response) {
        //         console.log(response.data)
        //         setTotalAdmins(response.data.result)
        //     })
        //     .catch(function (error) {
        //         if (error.response) {
        //             console.log(error.response);
        //         } else {
        //             console.log("An error occurred")
        //         }
        //     })
    }, [currentPage]);

    // DEACTIVATE ACCOUNT
    useEffect(() => {
        console.log(selectedAdmin.id)
    }, [selectedAdmin])


    const deactivate = (email) => {
        setStatusPending(true)
        api.post(`${base_url}/auth/deactivate-account/`, {
            "email": email
        })
            .then(function (response) {
                console.log(response.data)
                fetchData()
                setStatusPending(false)

                successAlert("Account successfully De-Activated")

                if (searchResults.length > 0) {

                    let updatedAdmin;

                    const updatedSearchResults = searchResults.map(admin =>{
                        if (admin.email === email) {
                            updatedAdmin = { 
                                id: admin.id ,
                                userID: admin.userID,
                                fullName: admin.fullName ,
                                email: admin.email ,
                                phonenumber: admin.phonenumber,
                                customerType: admin.customerType,
                                isUploadDocCompleted: admin.isUploadDocCompleted,
                                isRegistrationCompleted: admin.isRegistrationCompleted,
                                isApproved: admin.isApproved,
                                profilePicture: admin.profilePicture,
                                customer_id: admin.customer_id,
                                CashAccountNo: admin.CashAccountNo,
                                BVN: admin.BVN ,
                                createdAt: admin.createdAt,
                                updatedAt: admin.updatedAt, 
                                isActive: 0 };
                          } else {
                            updatedAdmin = admin;
                          }

                          return updatedAdmin;

                        });


                    setSearchResults(updatedSearchResults);
                }
                

            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                    errorAlert(error.response)

                } else {
                    console.log("An error occurred")
                    errorAlert("An error occurred")

                }
                setStatusPending(false)
            })
    }

    // ACTIVATE ACCOUNT
    const activate = (email) => {
        setStatusPending(true)
        api.post(`${base_url}/auth/activate-account/`, {
            "email": email
        })
            .then(function (response) {
                console.log(response.data)
                fetchData()
                setStatusPending(false)
                successAlert("Account successfully activated")

                if (searchResults.length > 0) {

                    let updatedAdmin;

                    const updatedSearchResults = searchResults.map(admin =>{
                        if (admin.email === email) {
                            updatedAdmin = { 
                                id: admin.id ,
                                userID: admin.userID,
                                fullName: admin.fullName ,
                                email: admin.email ,
                                phonenumber: admin.phonenumber,
                                customerType: admin.customerType,
                                isUploadDocCompleted: admin.isUploadDocCompleted,
                                isRegistrationCompleted: admin.isRegistrationCompleted,
                                isApproved: admin.isApproved,
                                profilePicture: admin.profilePicture,
                                customer_id: admin.customer_id,
                                CashAccountNo: admin.CashAccountNo,
                                BVN: admin.BVN ,
                                createdAt: admin.createdAt,
                                updatedAt: admin.updatedAt, 
                                isActive: 1 };
                          } else {
                            updatedAdmin = admin;
                          }

                          return updatedAdmin;

                        });


                    setSearchResults(updatedSearchResults);
                }


            })
            .catch(function (error) {
                if (error.response) {
                    console.log(error.response);
                    errorAlert(error.response)

                } else {
                    console.log("An error occurred")
                    errorAlert("Account successfully activated")

                }
                setStatusPending(false)
            })
    }

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const handleSearchInputChange = async (event) => {
        const searchString = event.target.value;
        setSearchString(searchString);
        if (searchString.trim() === "") {
            setSearchResults([]);
            return;
        }
        try {
            const response = await api.get(`${base_url}/user/search/${searchString}`);
            setSearchResults(response.data.searchResults);
        } catch (error) {
            console.log(error);
        }
    };
    // navigation options
    // const nextPage = () => {
    //     if (currentPage < Math.ceil(totalAdmins / itemsPerPage)) {
    //         setCurrentPage(currentPage + 1);
    //     }
    // };
    // const prevPage = () => {
    //     if (currentPage > 1) {
    //         setCurrentPage(currentPage - 1);
    //     }
    // };
    // const firstPage = () => {
    //     setCurrentPage(1);
    // };
    // const lastPage = () => {
    //     setCurrentPage(Math.ceil(totalAdmins / itemsPerPage));
    // };
    // const pageButtons = () => {
    //     const totalPages = Math.ceil(totalAdmins / itemsPerPage);
    //     const buttons = [];

    //     // Display up to 3 page numbers ahead of the current page
    //     for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
    //         buttons.push(
    //             <button
    //                 key={i}
    //                 className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
    //                 onClick={() => setCurrentPage(i)}
    //             >
    //                 {i}
    //             </button>
    //         );
    //     }

    //     return buttons;
    // };
    // end navigation options
    return (
        <>
            <div>
                <ToastContainer />
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi bi-person"></i> ALL ADMINS 
                            {/* <small className="text-secondary" style={{ fontWeight: "400", fontSize: "smaller" }}>({totalAdmins})</small> */}
                        </h6>
                    </div>
                    <div className="d-flex justify-content-end align-items-center flex-fill text-end">
                    <div className="input-group ms-1" style={{ width: '250px' }}>
                    {/* <input
                      type="text"
                      className="form-control custom-input-group"
                      placeholder="Search admins..."
                      value={searchString}
                      onChange={handleSearchInputChange}
                    /> */}
                    </div>
                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>Email</th>
                                <th>Tel</th>
                                <th>Status</th>
                                <th>
                                    Manage
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                adminsPending ? (
                                    <tr>
                                        <td colSpan="6" className="text-center my-">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    (searchResults.length > 0 ? searchResults : sortedAdmins).map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.email}</td>
                                            <td>{item.phonenumber}</td>
                                            <td>{item.isActive === false ? (
                                                <span className='text-danger bold'>Not Active <i className='bi-exclamation-circle'></i></span>
                                            ) : (
                                                <span className='text-success bold'>Active <i className='bi-check-circle'></i></span>
                                            )}</td>

                                            {/* <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td> */}
                                            {/* <td>
                                                <button className="btn-custom-sm" data-bs-toggle="modal" data-bs-target="#view-admin" onClick={() => viewAdmin(index)}>
                                                    View
                                                </button>
                                            </td> */}
                                            <td>
                                                {
                                                    item.isActive === false ? (
                                                        <div>
                                                            {
                                                                statusPending ? (
                                                                    <button className="btn-success-sm btn-sm mb-1 disabled-btn" style={{ width: "130px" }}>Activate</button>
                                                                ) : (
                                                                    <button className="btn-success-sm btn-sm mb-1" style={{ width: "110px" }} onClick={() => activate(item.email)}>Activate</button>
                                                                )
                                                            }

                                                        </div>
                                                    ) : (
                                                        <div>
                                                            {
                                                                statusPending ? (
                                                                    <button className="btn-danger-sm btn-sm mb-1 disabled-btn" style={{ width: "130px" }}>Deactivate</button>

                                                                ) : (
                                                                    <button className="btn-danger-sm" style={{ width: "110px" }} onClick={() => deactivate(item.email)}>Deactivate</button>

                                                                )
                                                            }

                                                        </div>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                )
                            }
                        </tbody>
                    </table>
                </div>

                {/* <div className="pagination btn-group">
                {searchResults.length === 0 && totalAdmins > itemsPerPage && (
                        <>
                    <button
                        className="btn-pagination"
                        onClick={firstPage}
                        disabled={currentPage === 1}
                    >
                        First
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={prevPage}
                        disabled={currentPage === 1}
                    >
                        <i className="bi-chevron-left"></i>
                    </button>

                    {pageButtons()}

                    <button
                        className="btn-pagination"
                        onClick={nextPage}
                        disabled={currentPage === Math.ceil(totalAdmins / itemsPerPage)}
                    >
                        <i className="bi-chevron-right"></i>
                    </button>

                    <button
                        className="btn-pagination"
                        onClick={lastPage}
                        disabled={currentPage === Math.ceil(totalAdmins / itemsPerPage)}
                    >
                        Last
                    </button>
                    </>
                    )}
                </div> */}

            </div>

            {/* Modal data content */}
            <div className="modal fade" id="view-admin">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">

                        {/* <!-- Modal Header --> */}
                        <div className="modal-header">
                            <h4 className="text-custom text-uppercase bold mt-3"><i className="bi-person"></i> {selectedAdmin.fullName}</h4><br />
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>

                        {/* <!-- Modal body --> */}
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt><i className='bi-envelope'></i> Email</dt>
                                            <dd>{selectedAdmin.email}</dd>

                                            <dt><i className='bi-telephone'></i> Phone Number</dt>
                                            <dd>{selectedAdmin.phonenumber}</dd>

                                            <dt><i className='bi-fingerprint'></i> BVN</dt>
                                            <dd>{selectedAdmin.BVN ? (selectedAdmin.BVN) : (<>No BVN Information</>)}</dd>

                                            <dt><i className='bi-calendar-range'></i> Creation Date</dt>
                                            <dd>{moment(selectedAdmin.createdAt).format('DD MMM YYYY h:mm:ss a')}</dd>
                                        </dl>
                                    </div>
                                    <div className="col-sm-6">
                                        <dl>
                                            <dt><i className='bi-list-check'></i> Registeration status</dt>
                                            <dd>{selectedAdmin.isRegistrationCompleted ? (<span className='text-success'>Completed <i className='bi-check-circle-fill'></i></span>) : (<span className='text-danger'>Not Completed <i className='bi-x-circle-fill'></i></span>)}</dd>

                                            <dt><i className='bi-list-check'></i> Documents status</dt>
                                            <dd>{selectedAdmin.isUploadDocCompleted ? (<span className='text-success'>Uploaded <i className='bi-check-circle-fill'></i></span>) : (<span className='text-danger'>Not Uploaded <i className='bi-x-circle-fill'></i></span>)}</dd>

                                            <dt><i className='bi-list-check'></i> Approval Status</dt>
                                            <dd>{selectedAdmin.isApproved ? (<span className='text-success'>Account Approved <i className='bi-check-circle-fill'></i></span>) : (<span className='text-danger'>Not Approved <i className='bi-x-circle-fill'></i></span>)}</dd>

                                            <dt><i className='bi-person-circle'></i> Account status</dt>
                                            <dd className='mb-3'>{selectedAdmin.isActive === false ? (<span className='text-danger'>Not Active <i className='bi-x-circle-fill'></i></span>) : (<span className='text-success'> Active <i className='bi-check-circle-fill'></i></span>)}</dd>

                                        </dl>
                                    </div>

                                    {/* <div className='col-12'>
                                        <div className="p-2 bg-light rounded">
                                            <dt><i className='bi-person-circle'></i> Account status</dt>
                                            <dd className='mb-3'>{selectedAdmin.isActive === 0 ? (<>Not Active</>) : (<span className='text-success'> Active <i className='bi-check-circle-fill'></i></span>)}</dd>
                                            
                                            {/* {
                                                selectedAdmin.isActive === 0 ? (
                                                    <div>
                                                        {
                                                            statusPending ? (
                                                                <button className="btn-custom mb-1 disabled-btn">Activating ...<i className="bi-check-circle"></i></button>
                                                            ) : (
                                                                <button className="btn btn-success btn-sm mb-1" onClick={() => activate(selectedAdmin.email, selectedAdmin.id)}>Activate <i className="bi-check-circle"></i></button>
                                                            )
                                                        }

                                                    </div>
                                                ) : (
                                                    <div>
                                                        {
                                                            statusPending ? (
                                                                <button className="btn btn-danger btn-sm disabled-btn">Deactivating ...<i className="bi-x-circle"></i></button>

                                                            ) : (
                                                                <button className="btn btn-danger btn-sm" onClick={() => deactivate(selectedAdmin.email, selectedAdmin.id)}>Deactivate <i className="bi-x-circle"></i></button>

                                                            )
                                                        }

                                                    </div>
                                                )
                                            } 

                                        </div>
                                    </div> */}
                                </div>

                            </div>
                        </div>

                        {/* <!-- Modal footer --> */}
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
            {/* End modal data content */}
        </>
    );
};

export default Admins;

